"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mountSearchParams(parameters) {
    if (parameters === void 0) { parameters = {}; }
    return Object.keys(parameters).map(function (key) { return key + '=' + parameters[key]; }).join('&');
}
exports.mountSearchParams = mountSearchParams;
function isElement(element) {
    return element instanceof Element;
}
exports.isElement = isElement;
function validateRequiredFields(object, requiredFields) {
    var isValid = true;
    var invalidField = null;
    requiredFields.forEach(function (field) {
        var hasField = Object.keys(object).includes(field);
        if (!hasField) {
            isValid = false;
            invalidField = field;
        }
    });
    return { isValid: isValid, invalidField: invalidField };
}
exports.validateRequiredFields = validateRequiredFields;



//////////////////
// WEBPACK FOOTER
// ./~/@hotmart/event-agent-js/dist/utils.js
// module id = 209
// module chunks = 0